
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Vector","d":"M19.18 3.617a6.474 6.474 0 00-5.18 2.6 6.477 6.477 0 00-11.667 3.922 12.458 12.458 0 00.607 3.862c1.843 5.833 7.525 9.316 10.336 10.278a2.544 2.544 0 001.447 0c2.812-.957 8.493-4.445 10.337-10.278a12.458 12.458 0 00.607-3.862 6.5 6.5 0 00-6.487-6.522z","fill":"#bac1cc","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M12.396 8.566a.875.875 0 01-.819 1.31 3.821 3.821 0 00-3.983 2.3.875.875 0 01-1.573-.768A5.57 5.57 0 0111.7 8.13a.874.874 0 01.697.436z","fill":"#bac1cc"}})])
          )
        }
      }
    